import { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import Box from '../../lib/appfuse-react/component/Box';
import Banner from '../../component/Banner';
import Resume from '../Resume';
import { settingService } from '../../service/setting/settingService';
import { useStyles } from './styles';

function Main() {
  const classes = useStyles();
  const [ready, setReady] = useState(false);
  const [departmentList, setDepartmentList] = useState(null);

  const handleBannerLoad = () => {
    setReady(true);
  };

  return (
    <Box className={classes.root} backgroundOpacity={0.5}>
      <Banner onLoad={handleBannerLoad} />
      {ready ? (
        <Resume departmentList={departmentList} />
      ) : (
        <Box className={classes.loadingContainer}>
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
}

export default Main;
